import { Subject } from "rxjs"
import { GenMessage } from "data/interface/message"
import { clearlocal, setlocal } from "data/lib/local-json"

// private module logic //

const authStream = new Subject<GenMessage>()

function logout(): void {
  setlocal('auth_loggedout', true)  // handled in legacy
  clearlocal('appMode');
  window.location.replace('/');
}

// public module interface //

const authService = {
  stream: () => authStream.asObservable(),
  logout: () => logout()
}

export default authService
